import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import styles from "./styles.module.scss";
import Selector from "../Selector";
const SelectorGroup = ({ values, setValues, maxChoices, options, variant = "standard", }) => {
    const toggleValue = (value) => {
        if (Array.isArray(values)) {
            const setValuesTyped = setValues;
            if (values.includes(value)) {
                setValuesTyped(values.filter((x) => x !== value));
            }
            else {
                if (values.length >= maxChoices && maxChoices > 1) {
                    return;
                }
                setValuesTyped([...values, value]);
            }
        }
        else {
            const setValuesTyped = setValues;
            setValuesTyped(value);
        }
    };
    return (_jsx("div", { className: cx({
            [styles.twoColumns]: variant === "standard",
            [styles.flavor]: variant === "flavor",
            [styles.long]: variant === "long",
        }), children: options.map((opt) => {
            return (_jsx(Selector, { ...opt, selected: maxChoices > 1 ? values.includes(opt.value) : values === opt.value, onClick: () => {
                    toggleValue(opt.value);
                }, variant: variant }, opt.value));
        }) }));
};
export default SelectorGroup;
